import {useInitActionCombo} from '../../../commons/combobox/initActionCombo.js';

import {useRemoteCombobox} from '@/setup/remoteCombobox.js';
import {reactive, getCurrentInstance, ref, computed} from 'vue';

export const useBUTransferDepositDetailData = () => {
  const {proxy} = getCurrentInstance();
  const {comboboxLoadData, submitQuickAdd} = useRemoteCombobox();

  // Tạo object lưu dữ liệu các field
  const comboboxDataRemote = reactive({
    budget_source_name: [],
    budget_chapter_code: [],
    budget_sub_kind_item_code: [],
    budget_item_code: [],
    budget_fees_id: [],
    project_code: [],
    bank_account: [],
    activity_name: [],
    statistic_code: [],
    debit_account: [],
    credit_account: [],
    accounting_object_code: [],
  });

  function initGridColumnParallel() {
    return [
      {
        caption: 'Diễn giải',
        dataField: 'description',
        columnType: proxy.$ms.constant.ColumnType.Text,
        width: 250,
        editable: true,
        sortable: true,
      },
      {
        caption: 'TK Nợ',
        title: 'Tài khoản Nợ',
        dataField: 'debit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'TK Có',
        title: 'Tài khoản Có',
        dataField: 'credit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Số tiền',
        dataField: 'amount_oc',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Quy đổi',
        dataField: 'amount',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        visible: false,
        sortable: true,
        rules: [
          {
            name: 'lessThanAmount',
            compareValue: 100000000000000,
          },
        ],
      },
      {
        caption: 'Nguồn',
        dataField: 'budget_source_name',
        width: 250,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mã dự phòng',
        dataField: 'budget_provide_code',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Chương',
        dataField: 'budget_chapter_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Khoản',
        dataField: 'budget_sub_kind_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mục',
        dataField: 'budget_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiểu mục',
        dataField: 'budget_sub_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiết tiểu mục',
        dataField: 'budget_detail_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Cấp phát',
        dataField: 'method_distribute_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 150,
        sortable: true,
        enum: 'MethodDistributeType',
      },
      {
        caption: 'Nghiệp vụ',
        dataField: 'cash_withdraw_type_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 150,
        sortable: true,
        enum: 'CashWithDrawType',
      },
      {
        caption: 'Hoạt động',
        dataField: 'activity_name',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        sortable: true,
      },
      {
        caption: 'CTMT, dự án',
        title: 'Chương trình mục tiêu, dự án',
        dataField: 'project_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        caption: 'Tài khoản NH, KB',
        title: 'Tài khoản ngân hàng, kho bạc',
        dataField: 'bank_account',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        caption: 'Phí, lệ phí',
        title: 'Phí, lệ phí',
        dataField: 'budget_fees_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        width: 100,
        caption: 'Đề tài',
        editable: true,
        sortable: true,
        dataField: 'topic_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        filterable: true,
      },
      {
        width: 100,
        caption: 'Hợp đồng',
        editable: true,
        sortable: true,
        dataField: 'contract_no',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
      },
      {
        width: 100,
        caption: 'Nhiệm vụ',
        dataField: 'task_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        width: 100,
        caption: 'Nguồn năm trước',
        editable: true,
        sortable: true,
        dataField: 'is_source_before_year',
        columnType: proxy.$ms.constant.ColumnType.Checkbox,
      },
      {
        caption: '',
        dataField: 'rowAction',
        width: 80,
        columnType: proxy.$ms.constant.ColumnType.Action,
        sortable: false,
      },
    ];
  }

  // Khởi tạo các field của grid
  const columnParallel = reactive(initGridColumnParallel());

  // toggle detail
  const toggleAbove = ref(true);
  const toggleAboveHandler = () => {
    toggleAbove.value = !toggleAbove.value;
  };

  // Active tab hạch toán hay thống kê
  const selectedTab = ref(1);

  /**
   * Biến dùng để disabled Sinh chứng từ chuyển khoản KB vào TK tiền gửi
   * NXCHIEN 26.04.2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled Sinh chứng từ ngược lại
   * NXCHIEN 26.04.2022
   */
  const genData = computed(() => {
    return proxy._formParam?.data?.IsGenerateData || proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled Xóa nếu chứng từ đã ghi sổ
   * NXCHIEN 26.04.2022
   */
  const disabledDelete = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
  });

  // item của button tiện ích CK tiền gửi
  const buttonTransferDeposit = reactive([
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      position: {
        at: 'right+15 top',
        my: 'left top',
      },
      subItem: [
        {
          text: 'Chuyển khoản kho bạc',
          command: 'ShowBUTransfer',
          isDisableWhenOffline: true,
        },
        {
          text: 'Chuyển khoản kho bạc vào TK tiền gửi',
          command: 'ShowBUTransferDeposit',
        },
      ],
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      subItem: [
        {
          text: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUTransferDepositDetail',
          refType: proxy.$ms.constant.RefType.BUTransferDeposit,
          initial: true,
        },
        {
          text: 'Thu tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BADepositDetail',
          refType: proxy.$ms.constant.RefType.BADeposit,
          isDisableWhenOffline: true,
        },
        {
          text: 'Chi tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BAWithDrawDetail',
          refType: proxy.$ms.constant.RefType.BAWithDraw,
          isDisableWhenOffline: true,
        },
      ],
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   disabledItem: disabledDelete,
    // },

    {
      text: 'Xem số dư tài khoản',
      command: 'ViewAccount',
      isDisableWhenOffline: true,
    },
    {
      text: 'Sinh giấy rút dự toán',
      command: 'GenerateData',
      disabledItem: genData,
      isDisableWhenOffline: true,
    },
    {
      text: 'Sinh chứng từ trả lương',
      command: 'GenerateDrawSalary',
      disabledItem: valueMode,
      isDisableWhenOffline: true,
    },
  ]);

  // item của button tiện ích CK kho bạc
  const buttonTransfer = reactive([
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
      IsSubMenu: true,
      subItem: [
        {
          text: 'Phiếu thu',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptDetail',
          refType: proxy.$ms.constant.RefType.CAReceipt,
        },
        {
          text: 'Phiếu thu rút dự toán nhập quỹ',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptPlanWithdrawDetail',
          refType: proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
        },
        {
          text: 'Phiếu chi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAPaymentDetail',
          refType: proxy.$ms.constant.RefType.CAPayment,
        },
        {
          text: 'Chuyển khoản kho bạc',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUTransferDetail',
          refType: proxy.$ms.constant.RefType.BUTransfer,
          initial: true,
        },
        {
          text: 'Chứng từ nghiệp vụ khác',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'GLGeneralVoucherDetail',
          refType: proxy.$ms.constant.RefType.GLGeneralVoucher,
        },
        {
          text: 'Chi tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BAWithDrawDetail',
          refType: proxy.$ms.constant.RefType.BAWithDraw,
        },
        {
          text: 'Thu tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BADepositDetail',
          refType: proxy.$ms.constant.RefType.BADeposit,
        },
      ],
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   disabledItem: disabledDelete,
    // },
    {
      text: 'Xem số dư tài khoản',
      command: 'ViewAccount',
    },
    {
      text: 'Sinh giấy rút dự toán',
      command: 'GenerateData',
      disabledItem: genData,
    },
    {
      text: 'Cất thành định khoản tự động',
      command: 'AddAutoBusiness',
    },
  ]);
  // item của button tiện ích CK tiền gửi
  const buttonTreasyFundTransferSalary = reactive([
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      position: {
        at: 'right+15 top',
        my: 'left top',
      },
      subItem: [
        {
          text: 'Chuyển khoản kho bạc',
          command: 'ShowBUTransfer',
        },
        {
          text: 'Chuyển khoản kho bạc vào TK tiền gửi',
          command: 'ShowBUTransferDeposit',
        },
      ],
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   seperatorBottom: true,
    //   disabledItem: disabledDelete,
    // },
    {
      text: 'Xem số dư tài khoản',
      command: 'ViewAccount',
    },
    {
      text: 'Hạch toán chi phí lương',
      command: 'GenerateData',
      disabledItem: valueMode,
    },
  ]);
  // item của button tiện ích CK tiền gửi
  const buttonTreasuryFundTransferInsurancePayment = reactive([
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      position: {
        at: 'right+15 top',
        my: 'left top',
      },
      subItem: [
        {
          text: 'Chuyển khoản kho bạc',
          command: 'ShowBUTransfer',
        },
        {
          text: 'Chuyển khoản kho bạc vào TK tiền gửi',
          command: 'ShowBUTransferDeposit',
        },
      ],
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   seperatorBottom: true,
    //   disabledItem: disabledDelete,
    // },
    {
      text: 'Xem số dư tài khoản',
      command: 'ViewAccount',
    },
    {
      text: 'Hạch toán chi phí bảo hiểm',
      command: 'GenerateData',
      disabledItem: valueMode,
    },
  ]);
  // item button in
  const buttonPrints = [
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
      report_id: '561.01.ND11.2020_Portrait',
      input_type_name: 'PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline',
    },
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
      report_id: '561.01.ND11.2020',
      input_type_name: 'PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline',
    },
    {
      text: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
      report_id: 'C2.02a_ND112020_561',
      input_type_name: 'C202aNSND112020_WithBankAccount_Offline',
    },
    {
      text: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
      report_id: 'C2.02b_ND112020_561',
      input_type_name: 'C202bNSND112020_WithBankAccount_Offline',
    },
    {
      text: 'C4-08/KB: Giấy nộp tiền vào tài khoản (Thông tư 19/2020/TT-BTC)',
      report_id: 'C408_TT19',
      input_type_name: 'C408_KB_TT19',
    },
    {
      text: 'Chứng từ kế toán',
      report_id: '561AccountantVoucher',
      input_type_name: 'ReportParamAccountVoucher_Offline',
    },
    {
      text: 'Chứng từ kế toán (Mẫu nguyên tệ)',
      report_id: '56OriginalCurrency',
      input_type_name: 'ReportParamAccountVoucher_Offline',
    },
  ];

  // Định khoản nhanh trong form detail chuyển khoản kho bạc
  const autoBusiness = [
    {
      text: 'Rút tạm ứng chưa cấp dự toán chi các khoản chi phí khác p/v HĐKTX',
      command: 'Transfer',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán chi các khoản chi phí khác p/v HĐTX',
      command: 'Transfer',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán KPTX nộp BHXH, BHYT, BHTN',
      command: 'Transfer',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán KPTX trả lương cho CB CNV',
      command: 'Transfer',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán mua văn phòng phẩm HĐ không thường xuyên',
      command: 'Transfer',
      seperatorBottom: true,
    },
    {
      text: 'Định khoản tự động',
      command: 'Transfer',
    },
  ];

  //#region khởi tạo config cho combox trong grid
  const {
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    budgetDetailItemComboConfig,
    accountComboConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    accountComboMostDetailConfig,
    contractComboConfig,
    TaskComboConfig,
    topicComboConfig,
    budgetProvideComboConfig,
    accountComboParalellConfig,
    fundStructureComboConfig,
    typeOfFundComboConfig,
    budgetFeesComboConfig,
  } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);
  //#endregion

  return {
    autoBusiness,
    buttonTransfer,
    buttonTransferDeposit,
    buttonPrints,
    comboboxDataRemote,
    columnParallel,
    toggleAbove,
    toggleAboveHandler,
    selectedTab,
    // config các field của grid ở dạng combo
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetKindItemComboConfig,
    budgetSubKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    accountComboConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    accountComboMostDetailConfig,
    contractComboConfig,
    topicComboConfig,
    TaskComboConfig,
    budgetProvideComboConfig,
    budgetDetailItemComboConfig,
    fundStructureComboConfig,
    typeOfFundComboConfig,
    accountComboParalellConfig,
    budgetFeesComboConfig,

    // func combo
    submitQuickAdd,
    comboboxLoadData,

    buttonTreasyFundTransferSalary,
    buttonTreasuryFundTransferInsurancePayment,
  };
};
